export default "__VITE_ASSET__D0p2hh9C__"